// extracted by mini-css-extract-plugin
module.exports = {"benefitItem":"SubscriptionBenefits_benefitItem__c_AbQ","benefitsList":"SubscriptionBenefits_benefitsList___g4ke","checkIcon":"SubscriptionBenefits_checkIcon__lY4if"};